import { Card } from "antd";
import SyntaxHighlighter from "react-syntax-highlighter";
import CopyButton from "./CopyButton";
import { idea } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { useState } from "react";
import VisibilityButton from "./VisibilityButton";

const CodeBlock: React.FC<{ type: "htmlbars" | "css" | "javascript", file: string, content: string }> = ({ type, file, content }) => {
    const [showContent, setShowContent] = useState(true);

    const changeVisibility = () => {
        setShowContent(!showContent);
    }

    return <Card
        title={file}
        extra={[
            <CopyButton key="copy" content={content} />,
            <VisibilityButton key="view" showContent={showContent} changeVisibility={changeVisibility} />,
        ]}
    >
        {showContent ?
            <SyntaxHighlighter language={type} style={idea} showLineNumbers wrapLines>
                {content}
            </SyntaxHighlighter>
            : "[ ... ]"}
    </Card>
}

export default CodeBlock;